var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageTranslatePurpleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.244,
    height: 12.771,
    viewBox: "0 0 13.244 12.771",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "translate",
    transform: "translate(-12 -12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83755",
    "data-name": "Path 83755",
    d: "M99.671,91.1h1.017L97.85,84H96.738L93.9,91.1h1.017l.757-1.892h3.24Zm-3.618-2.838,1.239-3.1,1.244,3.1Z",
    transform: "translate(-75.443 -66.324)",
    fill: "#a80ced"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83756",
    "data-name": "Path 83756",
    d: "M19.568,14.365v-.946H16.257V12h-.946v1.419H12v.946h5.08a6.958,6.958,0,0,1-1.509,2.923,6.385,6.385,0,0,1-1.083-1.977h-.993a7.79,7.79,0,0,0,1.419,2.639,7.965,7.965,0,0,1-2.441,1.618l.355.88a8.736,8.736,0,0,0,2.734-1.826,8,8,0,0,0,2.725,1.816l.336-.87A6.849,6.849,0,0,1,16.2,17.974a8.344,8.344,0,0,0,1.854-3.609Z",
    fill: "#a80ced"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageTranslatePurpleIcon);
export default __webpack_public_path__ + "static/media/message-translate-purple-icon.3846983211eb09d89a33c94ca7da62a9.svg";
export { ForwardRef as ReactComponent };